<template>
  <div class="picker">
    <div class="picker-head">
      <h1 class="picker-title">Hi, {{ userName }}</h1>
      <div class="picker-sub">Select a company to continue</div>
    </div>

    <v-text-field v-model="search" outlined dense hide-details clearable placeholder="Search companies"
      prepend-inner-icon="mdi-magnify" class="picker-search" background-color="white" />

    <div v-if="loading" class="picker-placeholder">
      <v-progress-circular indeterminate color="#3988AA" size="32" />
    </div>
    <div v-else-if="filteredCompanies.length === 0" class="picker-placeholder">
      <v-icon size="36" color="#D0D0D0">mdi-domain-off</v-icon>
      <div class="mt-2">{{ search ? 'No companies match your search' : 'You don\'t have access to any companies yet' }}</div>
    </div>
    <div v-else class="picker-grid">
      <button v-for="company in filteredCompanies" :key="company.id" type="button" class="company-tile"
        @click="selectCompany(company)">
        <span class="company-logo">
          <img v-if="company.company_logo && !broken_logos[company.id]" :src="api_url + company.company_logo"
            :alt="company.company_name" @error="$set(broken_logos, company.id, true)">
          <v-icon v-else size="28" color="#C8C8C8">mdi-domain</v-icon>
        </span>
        <span class="company-name">{{ company.company_name }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CompanyPicker',
  data: () => ({
    search: '',
    api_url: process.env.VUE_APP_API_URL,
    broken_logos: {},
  }),
  computed: {
    ...mapGetters({
      get_user: 'auth/get_user',
      get_companies: 'auth/get_companies',
    }),
    userName() {
      return ((this.get_user && this.get_user.name) || '').trim() || 'there'
    },
    // The sidebar fetches companies on mount; until then the list is undefined
    loading() {
      return !Array.isArray(this.get_companies)
    },
    filteredCompanies() {
      const term = (this.search || '').trim().toLowerCase()
      const companies = this.get_companies || []
      if (!term) return companies
      return companies.filter(c => (c.company_name || '').toLowerCase().includes(term))
    },
  },
  methods: {
    selectCompany(company) {
      this.$store.dispatch('auth/set_selected_company', company)
      // Same as the sidebar switcher: reload so every view picks up the new company
      this.$router.go(0)
    },
  },
}
</script>

<style lang="scss" scoped>
.picker {
  max-width: 1100px;
  margin: 0 auto;
  padding: 48px 0 32px;
  font-family: Manrope, sans-serif;
}

.picker-head {
  text-align: center;
  margin-bottom: 24px;
}

.picker-title {
  font-family: Manrope;
  font-size: 26px;
  font-weight: 800;
  color: #1F2A30;
  margin: 0;
}

.picker-sub {
  font-family: Manrope;
  font-size: 14px;
  color: #7C7C7C;
  margin-top: 4px;
}

.picker-search {
  margin-bottom: 20px;
}

.picker-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  color: #AAAAAA;
  font-family: Manrope;
  font-size: 13px;
  font-weight: 500;
}

.picker-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 12px;
}

.company-tile {
  display: flex;
  flex-direction: column;
  background: white;
  border: 1px solid #E9E9E9;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  text-align: center;
  box-shadow: 5px 5px 13px 0px rgba(240, 240, 240, 0.90);
  transition: border-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;

  &:hover,
  &:focus-visible {
    outline: none;
    border-color: #B9D8E6;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(57, 136, 170, 0.15);
  }
}

.company-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 96px;
  padding: 8px 12px;
  background: #F7F9FB;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
}

.company-name {
  display: block;
  padding: 12px;
  font-family: Manrope;
  font-size: 13px;
  font-weight: 700;
  color: #1F2A30;
  border-top: 1px solid #F2F2F2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
